import { render, staticRenderFns } from "./PgaExpertiseCreate.vue?vue&type=template&id=3bd5578e&"
import script from "./PgaExpertiseCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaExpertiseCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VDivider,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd5578e')) {
      api.createRecord('3bd5578e', component.options)
    } else {
      api.reload('3bd5578e', component.options)
    }
    module.hot.accept("./PgaExpertiseCreate.vue?vue&type=template&id=3bd5578e&", function () {
      api.rerender('3bd5578e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Expertises/Components/PgaExpertiseCreate.vue"
export default component.exports